export default __webpack_public_path__ + "static/media/post-4.fedaf818.png";